import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const REMINDER_OPTIONS = [
  { value: "0d", label: "0 day", short: "0d" },
  { value: "2w", label: "2 weeks prior", short: "2w" },
  { value: "10w", label: "10 weeks prior", short: "10w" },
  { value: "4m", label: "4 months prior", short: "4m" },
  { value: "6m", label: "6 months prior", short: "6m" },
];

export const EXPIRATION_EVENTS = [
  { key: "passport_expiration", label: "Passport Expiration" },
  { key: "visa_expiration", label: "Visa Expiration" },
  { key: "english_test_due", label: "IELTS / PTE Expiration" },
  { key: "naati_expiration", label: "NAATI Expiration" },
  { key: "skill_assessment_expiration", label: "Skill Assessment Expiration" },
  { key: "py_expiration", label: "PY Expiration" },
];

// Rendered in the client profile alongside the configurable events. Tuition
// fee has multiple dates and always uses a fixed 3-week (21-day) lead time.
export const TUITION_FEE_LEAD_DAYS = 21;
